import React, { Component } from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";

// Components
import Tooltip from "./../utils/Tooltip";

// CSS
import "./../../css/button.css";

// State
import { addToCart, clearSuccess } from "./../../store/actions/cart";
import { revertCheckoutAfterCartChanged } from "../../store/actions/checkout";

// Util
import { addToCart as addToCartGA } from "../../utils/google-analytics";

class ProductBuyBtn extends Component {
	constructor(props) {
		super(props);
		this.componentCleanup = this.componentCleanup.bind(this);
	}

	componentDidMount() {
		// Clean up component if user refreshes/closes page
		window.addEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		// Clean up component if unmounting component (user goes to another page)
		this.componentCleanup();
	}

	componentCleanup() {
		// Clean up any flags or unnecessary state
		this.props.clearSuccess();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	addToCart() {
		this.props
			.addToCart(this.props.product.id, this.props.quantity, this.props.variantsSelected)
			.then(() => this.props.revertCheckoutAfterCartChanged());

		let categories = "";
		for (let i = 0; i < this.props.structure.length; i++) {
			if (categories !== "") {
				categories += "/";
			}
			categories += this.props.structure[i].title;
		}

		const variant_title = isEmpty(this.props.variant)
			? ""
			: this.props.variant.sku_text
					.map(item => {
						return item.txt;
					})
					.join("/");
		const productData = {
			id: this.props.product.sku,
			name: this.props.product.title,
			category: categories,
			variant: variant_title
		};

		// console.log("Calling GA addToCart()", this.props);
		addToCartGA(productData, this.props.final_price, this.props.quantity, this.props.variant);
	}

	render() {
		let disabled =
			this.props.product.inventory === undefined || this.props.product.inventory
				? false
				: true;
		let btnText =
			this.props.product.inventory === undefined || this.props.product.inventory
				? "Add to cart"
				: "Out of stock";

		if (this.props.inProcess) {
			disabled = true;
		}

		let showErrorTooltip = this.props.error !== undefined;
		let showSuccessTooltip = this.props.success !== undefined;

		return (
			<div className="btn_container">
				<button
					className="btn buy_btn"
					ref={addBtn => (this.addBtn = addBtn)}
					disabled={disabled}
					onClick={() => this.addToCart()}
				>
					{btnText}
				</button>
				{showErrorTooltip && this.addBtn && (
					<Tooltip
						parent={this.addBtn}
						type={"dialog--error"}
						messageObjects={this.props.error}
					/>
				)}
				{showSuccessTooltip && this.addBtn && (
					<Tooltip
						parent={this.addBtn}
						type={"dialog--success"}
						messageObjects={{ success: this.props.success }}
					/>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		inProcess: state.cart.inProcess,
		error: state.cart.error,
		success: state.cart.success,
		variantsSelected: state.productVariant.variant_options,
		variant: state.productVariant.variant,
		final_price: state.product.final_price
	};
}

export default connect(
	mapStateToProps,
	{ addToCart, revertCheckoutAfterCartChanged, clearSuccess }
)(ProductBuyBtn);



// WEBPACK FOOTER //
// ./src/components/product/ProductBuyBtn.js